import React from "react";
import AuthLayout from "../../components/auth/AuthLayout";
import PageTitle from "../../components/auth/PageTitle";
import ClubInfoSteps from "../../components/auth/ClubInfoSteps";
import ClubInfoForm2 from "../../components/auth/ClubInfoForm2";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";

const ClubInfo2 = () => {
  const { Auth }: DictionaryType = useGetDictionary();
  return (
    <AuthLayout>
      <div className="  flex flex-col gap-8 px-12">
        <div className="flex flex-col gap-5 text-center">
          <PageTitle title={Auth?.club_info_2.club_info_2_title} />
          <p className="text-lg font-normal leading-[22.68px] text-[#1E1850] mt-2">
            {Auth?.club_info_2.club_info_2_subtitle}
          </p>
        </div>
        <ClubInfoSteps
          servicesActive={true}
          courtsActive={false}
          hoursBold={true}
          servicesBold={true}
          courtsBold={false}
        />
        <p className="text-primary dark:text-white font-bold text-base capitalize">
          {Auth?.club_info_2.facilites_offer_title}
        </p>
        <ClubInfoForm2 />
      </div>
    </AuthLayout>
  );
};

export default ClubInfo2;
